import { Flex } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { AuthCallbackPath } from "../../../api-types/connector-callbacks";
import { CodatConnect } from "../../../components";
import { ConnectorNavigationGroup } from "../../../components/connect/common/navigation-group";
import { usePlatformConnectorProperties } from "../../../hooks/connector";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { CodatSupportingContent, ConnectorPageTemplate } from "../components";

import { MESSAGES } from "./message-definitions";

const CONNECTOR_SLUG = "codat_accounting";

export const CodatPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplication } = useFundingApplication(customerDomain);
  const { data: connectorProperties } = usePlatformConnectorProperties(
    customerDomain,
    CONNECTOR_SLUG,
    AuthCallbackPath.FUNDING_APPLICATION_ADD_CONNECTION
  );
  const hasConnections = !!connectorProperties.connections.length;

  const knownAccounting = fundingApplication.selectedUnsupportedAccounting.join(", ");

  return (
    <ConnectorPageTemplate
      title={intl.formatMessage(MESSAGES.connectTitle, { connectorName: knownAccounting })}
      primaryContent={
        <Flex direction="column" gap="8">
          <CodatConnect />
          <ConnectorNavigationGroup hasConnections={hasConnections} forSlug={CONNECTOR_SLUG} />
        </Flex>
      }
      secondaryContent={<CodatSupportingContent />}
    />
  );
};
